export function initFilterTitleDropdown() {
  document.querySelectorAll('.po-filter-title').forEach((filterBlock) => {
    const dropdownList = filterBlock.querySelector('.po-filter-title__list');
    const selectedLabel = filterBlock.querySelector(
      '.po-filter-title__selected-text'
    );
    const radioItems = filterBlock.querySelectorAll('input[type="radio"]');

    if (!selectedLabel || !radioItems.length) return;

    const toggleTrigger = filterBlock.querySelector(
      '.po-filter-title__wrapper'
    );
    if (toggleTrigger) {
      toggleTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        filterBlock.classList.add('po-filter-title_active');
        if (dropdownList) {
          dropdownList.classList.add('po-filter-title__list_active');
        }
      });
    }

    document.addEventListener('click', () => {
      filterBlock.classList.remove('po-filter-title_active');
      dropdownList?.classList.remove('po-filter-title__list_active');
    });

    const urlFilterParams = new URLSearchParams(window.location.search);
    const currentFilter = urlFilterParams.get('filter') || 'recommended';

    radioItems.forEach((radio) => {
      const label = radio.closest('label');
      if (!label) return;

      const labelText = label.textContent.trim();
      const redioValue = radio.dataset.value;

      if (currentFilter === redioValue) {
        radio.checked = true;
        selectedLabel.textContent = labelText;
      } else {
        radio.checked = false;
      }

      radio.addEventListener('change', () => {
        selectedLabel.textContent = labelText;

        const url = new URL(window.location);
        url.searchParams.set('filter', redioValue);
        window.location = url;
      });
    });
  });
}
